import ApiHandler from '@/api/base'

class CheckinTemplatesApiHandler extends ApiHandler {
  async getTemplates({ includeText = false, limit = 1e4, startAt = 0, workspaceIds = [] } = {}) {
    const { data } = await this.http.get('/checkin/templates', {
      params: {
        includeText,
        limit,
        startAt,
        workspaceIds
      }
    })

    return data
  }

  async createTemplate({ addToAllWorkspaces, emoji, text, title, workspaceIds }) {
    const { data } = await this.http.post('/checkin/templates', {
      addToAllWorkspaces,
      emoji,
      text,
      title,
      workspaceIds
    })

    return data
  }

  async getTemplateById(templateId) {
    const { data } = await this.http.get(`/checkin/templates/${templateId}`)
    return data
  }

  async updateTemplate(templateId, { addToAllWorkspaces, emoji, text, title, workspaceIds }) {
    const { data } = await this.http.put(`/checkin/templates/${templateId}`, {
      addToAllWorkspaces,
      emoji,
      text,
      title,
      workspaceIds
    })

    return data
  }

  async deleteTemplate(templateId) {
    const { data } = await this.http.delete(`/checkin/templates/${templateId}`)
    return data
  }

  async getTemplatesCapacity() {
    const { data } = await this.http.get('/checkin/templates/capacity')
    return data
  }
}

export default CheckinTemplatesApiHandler
